import rootElementWrapper from "./src/utils/rootElementWrapper";

export const wrapRootElement = rootElementWrapper;
